import DictionaryMappingService, { IProductMapping } from '@/creditflowresearch/domain/DictionaryMapping';
import type { IProduct } from '@/creditflowresearch/domain/vo/Product';
import type { IRegion } from '@/creditflowresearch/domain/vo/Region';
import type { IHeaderMenuItems } from '@/creditflowresearch/domain/vo/IHeaderMenuItems';

// The one place the header menu items become the product/region mapping, so the client header
// menu, the v1 dictionaries and server-side reads cannot drift apart.
const buildHeaderMapping = (
  products: IProduct[],
  regions: IRegion[],
  { toolsList, headerMapping }: IHeaderMenuItems,
) => DictionaryMappingService.handleMapping(products, regions, toolsList, headerMapping as IProductMapping);

export default buildHeaderMapping;
